

export enum KalturaNullableBoolean {
    falseValue=0,
	nullValue=-1,
	trueValue=1
}